import {ListSidebar, ListSidebarCollapsedButton} from '../shared/ListSidebar'
import type {TypeFilter} from '../types/repos-list-types'
import type {SidebarLink} from '../types/sidebar-types'

interface OrgSidebarProps {
  onQueryChanged: (query: string) => void
  type: string
  types: TypeFilter[]
}

const phraseByType: Record<string, string> = {
  all: '',
  public: 'visibility:public archived:false',
  internal: 'visibility:internal archived:false',
  private: 'visibility:private archived:false',
  source: 'mirror:false fork:false archived:false',
  fork: 'fork:true archived:false',
  template: 'template:true archived:false',
  archived: 'archived:true',
}

const iconByType: Record<string, SidebarLink['icon']> = {
  all: 'home',
  public: 'repo',
  internal: 'organization',
  private: 'repo-locked',
  source: 'link',
  fork: 'repo-forked',
  template: 'repo-template',
  archived: 'archive',
}

export function OrgSidebar({onQueryChanged, type, types}: OrgSidebarProps) {
  return (
    <ListSidebar links={getOrgLinks(types)} selectedLink={type} onSelectLink={link => onQueryChanged(link.query)} />
  )
}

export function OrgSidebarCollapsedButton(props: OrgSidebarProps) {
  return (
    <ListSidebarCollapsedButton
      links={getOrgLinks(props.types)}
      selectedLink={props.type}
      onSelectLink={link => props.onQueryChanged(link.query)}
    />
  )
}

export function getTypeFromQuery(query: string, types: TypeFilter[]) {
  return types.find(({id}) => phraseByType[id] === query.trim())?.id || ''
}

function getOrgLinks(types: TypeFilter[]): SidebarLink[] {
  return types.map(({id, text}) => ({
    id,
    name: text,
    searchType: 'repositories',
    query: getQueryFromType(id),
    icon: iconByType[id] || 'link',
    color: 'gray',
    source: 'predefined',
  }))
}

function getQueryFromType(type: string) {
  return phraseByType[type] || ''
}

try{ OrgSidebar.displayName ||= 'OrgSidebar' } catch {}
try{ OrgSidebarCollapsedButton.displayName ||= 'OrgSidebarCollapsedButton' } catch {}